import React from "react"
import { Link } from "gatsby"
import "./index.scss"
import { TagButton } from "../TagButton/index"

interface BlogListProps {
    slug: string;
    title: string;
    date: string;
    subTitle: string;
    tags: string[];
    readingTime: string;
}

export const BlogListTitle = ({ slug, title, date, subTitle, tags, readingTime }: BlogListProps) => {
    return (
        <div className="wrapper">
            <Link
                to={slug}
                style={{ textDecoration: `none`, color: `inherit` }}
            >
                <div className="card card-1">
                    <BlogListTitleHeader title={title} date={date} readingTime={readingTime} />
                    <p>{subTitle}</p>
                    <div className="button-container">
                        {tags.map((tag, index) => (
                            <TagButton key={index} text={tag} />
                        ))}
                    </div>
                </div>
            </Link>
        </div>
    )
}

export const BlogHeaderTitle = ({ title }) => <h3>{title}</h3>

const BlogListTitleHeader = ({ title, date, readingTime }) => (
    <div>
        <h3 style={{ margin: 0 }}>{title} <br /></h3>
        <h5>
            <BlogListTitleDate date={date} />
            <BlogListReadingTime readingTime={readingTime} />
        </h5>
    </div>
)

const BlogListTitleDate = ({ date }) => <span color="#BBB">— {date} </span>

const BlogListReadingTime = ({ readingTime }) => <> • 🧐 {readingTime}</>
